/**
 * Server rate limit (HTTP 429) — user-facing messages.
 * Backend may return payload: { message, retryAfter } (retryAfter in seconds).
 */

export function formatTooManyRequestsMessage(apiMessage, retryAfterSeconds) {
  const base =
    (apiMessage && String(apiMessage).trim()) ||
    'Too many requests. Please try again later.';
  if (
    retryAfterSeconds == null ||
    !Number.isFinite(retryAfterSeconds) ||
    retryAfterSeconds <= 0
  ) {
    return base;
  }
  const sec = Math.ceil(retryAfterSeconds);
  if (sec < 60) {
    return `${base} Try again in about ${sec} second${sec === 1 ? '' : 's'}.`;
  }
  const mins = Math.ceil(sec / 60);
  return `${base} Try again in about ${mins} minute${mins === 1 ? '' : 's'}.`;
}

function parseRetryAfterFrom429Body(data) {
  if (!data || typeof data !== 'object') return undefined;
  const raw = data.retryAfter;
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    return Math.max(0, raw);
  }
  if (typeof raw === 'string') {
    const n = parseInt(raw, 10);
    return Number.isFinite(n) ? Math.max(0, n) : undefined;
  }
  return undefined;
}

function parse429ApiMessage(data) {
  if (!data || typeof data !== 'object') return undefined;
  const m = data.message;
  return typeof m === 'string' && m.trim() ? m.trim() : undefined;
}

/**
 * Build message from axios error response (429).
 * @param {import('axios').AxiosError} error
 */
export function tooManyRequestsMessageFromAxiosError(error) {
  const data = error.response?.data;
  const apiMsg = parse429ApiMessage(data);
  let retry = parseRetryAfterFrom429Body(data);
  const headerRa = error.response?.headers?.['retry-after'];
  if (retry == null && headerRa != null) {
    const n = parseInt(String(headerRa), 10);
    if (Number.isFinite(n)) retry = Math.max(0, n);
  }
  return formatTooManyRequestsMessage(apiMsg, retry);
}
